(function(angular) {
    'use strict';

    var app = angular.module('asDemandMgr');

    app.service('agencyApi', [
        '$http',
        '$q',
        function($http, $q) {
            this.getList = function(sort, search, page) {
                var url = '/demandmgr/agency/list' + getReportUrl(sort, search, {}, page);

                return $q(function(resolve, reject) {
                    $http.get(url).then(
                        // success
                        function(res) {
                            resolve(res.data);
                        },
                        // error
                        function(res) {
                            console.log(res);

                            reject({ code: res.data.errorCode, message: res.data.message });
                        }
                    );
                });
            };

            this.delete = function(agencyId) {
                var url = '/demandmgr/agency?id=' + agencyId;

                return $q(function(resolve, reject) {
                    $http.delete(url).then(
                        function(res) {
                            resolve();
                        },
                        function(res) {
                            reject();
                        }
                    );
                });
            };

            this.read = function(ioId) {
                var url = '/demandmgr/agency/read?id=' + ioId;

                return $q(function(resolve, reject) {
                    $http.get(url).then(
                        // success
                        function(res) {
                            resolve(res.data);
                        },
                        // error
                        function(res) {
                            reject();
                        }
                    );
                });
            };

            this.save = function(agency) {
                var url = '/demandmgr/agency/save';

                return $q(function(resolve, reject) {
                    $http.post(url, agency).then(
                        // success
                        function(res) {
                            if (res.data.status === 'success') {
                                resolve();
                            } else {
                                reject(res.data);
                            }
                        },
                        // error
                        function(res) {
                            reject();
                        }
                    );
                });
            };

            this.isAgencyNameUnique = function(field, agencyName, agencyId) {
                var url =
                    '/demandmgr/agency/check-name?field=' +
                    field +
                    '&id=' +
                    (agencyId ? agencyId : 0) +
                    '&name=' +
                    agencyName;

                return $q(function(resolve, reject) {
                    $http.get(url).then(
                        // success
                        function(res) {
                            resolve(res.data);
                        },
                        // error
                        function(res) {
                            reject();
                        }
                    );
                });
            };
        },
    ]);
})(window.angular);
